import { gql } from '@apollo/client';

export const POST_FRAGMENT = gql`
fragment PostFragment on Post {
  id
  content
  locationName
  locationAddress
  locationCoordinates { x, y }
  visibility
  createdAt
  createdByUser {
    id
    name
    totalCredits
    username
    avatarUrl
    isTerritoryMentor
  }
  postLikes {
    totalCount
    nodes {
      createdByUserId
      id
    }
  }
  postComments(orderBy: CREATED_AT_DESC) {
    totalCount
    nodes {
      id
      postId
      createdByUser {
        id
        isTerritoryMentor
        name
        totalCredits
        avatarUrl
      }
      createdAt
      content
      replyToCommentId
    }
  }
  postAttachments(filter: {type: {equalTo: IMAGE}}, orderBy: POSITION_ASC) {
    nodes {
      id
      position
      url
      type
    }
  }
}
`;
